import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { onAuthStateChanged, type User } from "firebase/auth";
import { useUser } from "@/contexts";
import { auth } from "@/services/config";

const RequireAuth = () => {
  const location = useLocation();
  const { user, userData, loading } = useUser();

  // const [user, setUser] = useState<User | null>(null);
  // const [isLoading, setIsLoading] = useState(true);

  // console.log(user);

  // useEffect(() => {
  //   const unsubscribe = onAuthStateChanged(auth, (nextUser) => {
  //     setUser(nextUser);
  //     setIsLoading(false);
  //   });

  //   return unsubscribe;
  // }, []);

  if (loading) return null;

  if (!user || !user.emailVerified) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const hasValidSlug = !!userData?.usernameSlug;

  if (!hasValidSlug) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default RequireAuth;
